import NextImage from "next/image";

export default function Image({
  src,
  alt,
  width,
  style,
  fill,
  onLoad,
  draggable,
  sizes,
  local,
}: {
  src: string;
  alt: string;
  width?: number;
  fill?: boolean;
  style?: React.CSSProperties;
  onLoad?: (event: React.SyntheticEvent<HTMLImageElement>) => void;
  draggable?: boolean;
  sizes?: string;
  local?: boolean;
}) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <NextImage
        draggable={draggable ?? true}
        src={
          local
            ? src
            : "https://d163aeqznbc6js.cloudfront.net/images" +
              src +
              (width ? `?${new URLSearchParams({ w: width.toString() })}` : "")
        }
        {...(fill ? { fill } : {})}
        alt={alt}
        style={{
          objectFit: "cover",
          objectPosition: "center",
          margin: "0",
          padding: "0",
          boxSizing: "border-box",
          ...style,
        }}
        onLoad={onLoad}
        sizes={sizes}
      />
    </div>
  );
}
